import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';
import React, { useEffect, useState } from 'react';
import { AutoSubmitForm } from 'ui/AutoSubmitForm/AutoSubmitForm';
import { ErrorBar, LoadingBar } from 'ui/NetworkStatusBar';

export const OutlineRedirect = () => {
  const [tokens, setTokens] = useState<{ accessToken: string; refreshToken: string } | null>(null);
  const params = useDynamicParameters();
  const { KNOWLEDGEBASE_BASE_URL } = params.dynamicParameters;
  const submissionUrl = `${KNOWLEDGEBASE_BASE_URL}/auth/cognito`;

  useEffect(() => {
    const authJwtRaw = localStorage.getItem('AUTH_JWT');
    let accessToken: string | null = null;
    if (authJwtRaw) {
      accessToken = JSON.parse(authJwtRaw).value.substring(7);
    }
    const refreshToken = localStorage.getItem('REFRESH_TOKEN');

    if (accessToken && refreshToken) {
      setTokens({ accessToken, refreshToken });
    }
  }, []);

  if (!tokens) {
    return (
      <ErrorBar message="There was an error logging you into the knowledge base. Please re-login, and then try again." />
    );
  }

  return (
    <>
      <LoadingBar label="Redirecting you to knowledge base..." />
      <AutoSubmitForm
        action={submissionUrl}
        data={{
          accessToken: tokens.accessToken,
          refreshToken: tokens.refreshToken,
        }}
      />
    </>
  );
};
